import { addExternalScript } from '../../includes/utils';
import { cf7RecaptchaScript } from './cf7recaptcha';

/* ------------------------------------------------------------ */
/* -- CF7 + Recaptcha Init -- */
/* ------------------------------------------------------------ */
const cf7Init = () => {
  addExternalScript({ src: 'https://www.google.com/recaptcha/api.js?render=6Ld57yYjAAAAALMfLBqF_Phd6LVfk0RFdbToPPos&#038;ver=3.0', async: true }).then(() => cf7RecaptchaScript()).catch(err =>
    console.error(err),
  );
};

export default cf7Init;
